<div class="screen-container" [loading]="loading()" [ngClass]="{'congrat-bg': opened()}">
	<div class="mt-4">
		<lgb-back name="collect-home"></lgb-back>
	</div>
	<div class="scan-container">
		<div>
			@if(!opened()){
				<p class="title-xs font-serra">Active ton nouveau binder</p>
				<div [ngClass]="{'mt-4': (error() || msg())}">			
					<lgb-message [(error)]="error" [(msg)]="msg"></lgb-message>
				</div>
				<div class="scan-img">
					<img class="card-img" src="img/skin/binder-card.jpg"/>
					<img class="phone-img" src="img/skin/scan-card.svg"/>
				</div>
				<div class="action-container">
					<button (click)="enableScan.set(true)" class="btn bg-white text-primary border-[#e5e5e5] mb-2"><i class="fa-regular fa-barcode-scan"></i> QR Code</button>
					<button onclick="my_modal_1.showModal()" class="btn bg-white text-primary border-[#e5e5e5] mb-2"><i class="fa-light fa-binary"></i> Numéro du binder</button>
					<button (click)="openCustomBinder()" class="btn bg-white text-primary border-[#e5e5e5] mb-2">Binder sans numéro</button>
				</div>
			}
			@else{
				<p class="title-xs font-serra">Félicitations !</p>
				<div class="title-congrat subtitle">
					Félicitations, ton binder est prêt à être utilisé.
				</div>
				<div class="action-container">
					<a href="#" [routerLink]="router.parse('collect-binder', [binder().ident])" class="btn bg-white text-primary border-[#e5e5e5] mb-2">Ajouter des cartes</a>
					<button (click)="reset()" class="btn bg-white text-primary border-[#e5e5e5] mb-2">Activer un autre binder</button>
					<a href="#" [routerLink]="router.get('collect-home')" class="btn bg-white text-primary border-[#e5e5e5] mb-2">Retour</a>
				</div>
			}
		</div>
	</div>
</div>

<!-- scan -->
<lgb-scan-binder [enabled]="enableScan()" (close)="enableScan.set(false)" (success)="scan($event)"></lgb-scan-binder>

<!-- modal pour saisir le code -->
<dialog id="my_modal_1" class="modal">
  <div class="modal-box">
    <div class="">
    	Entrer le numéro du binder
    </div>
    <div>
		<!-- code -->
		<label class="floating-label my-4">
		  <span>Numéro de binders</span>
		  <input type="text" [(ngModel)]="code" placeholder="Numéro de binders" name="nbBinder" class="input input-md w-full" required />
		</label>
    </div>
    <div class="modal-action">
      <form method="dialog">
        <!-- if there is a button in form, it will close the modal -->
        <button class="btn">Retour</button>
        <button (click)="openBinder()" class="btn btn-primary btn-gradient">Activer</button>
      </form>
    </div>
  </div>
</dialog>